__turbopack_context__.v({
  "destination": "FirstRunGlobe-module__FYgEKG__destination",
  "earth-reveal": "FirstRunGlobe-module__FYgEKG__earth-reveal",
  "fallback": "FirstRunGlobe-module__FYgEKG__fallback",
  "surface": "FirstRunGlobe-module__FYgEKG__surface",
  "world": "FirstRunGlobe-module__FYgEKG__world",
});
